import { AlertTriangle, Loader2, XCircle } from "lucide-react";
import { describeParams, fmtTime } from "./meta";

export function RunRunning({ run }) {
  const pct = run.pct || 0;
  return (
    <div className="rounded-lg border border-slate-200 bg-white px-5 py-4" data-testid="bsp-running">
      <div className="flex items-center gap-2 text-sm font-medium text-slate-800">
        <Loader2 className="h-4 w-4 animate-spin text-emerald-600" /> Preview running — {run.step || "starting"}
        <span className="ml-auto font-mono text-xs tabular-nums text-slate-500" data-testid="bsp-running-pct">{pct}%</span>
      </div>
      <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-slate-100">
        <div className="h-full rounded-full bg-emerald-500 transition-[width] duration-700" style={{ width: `${Math.max(pct, 3)}%` }} />
      </div>
      <p className="mt-2 text-[11px] text-slate-500">{describeParams(run.params)} · started {fmtTime(run.started_at)} by {run.started_by_name}. A full run takes about a minute and a half — you can leave this page.</p>
    </div>
  );
}

export function RunFailed({ run }) {
  return (
    <div className="flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 px-5 py-4 text-sm text-red-800" data-testid="bsp-failed">
      <XCircle className="mt-0.5 h-4 w-4 shrink-0" />
      <div><b>The preview stopped.</b> <span data-testid="bsp-failed-error">{run.error}</span>
        <div className="mt-1 text-[11px] text-red-700/80">{describeParams(run.params)} · {fmtTime(run.started_at)}</div></div>
    </div>
  );
}

export function RunWarnings({ list }) {
  if (!list?.length) return null;
  return (
    <div className="space-y-1 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-xs text-amber-900" data-testid="bsp-warnings">
      {list.map((w) => <div key={w} className="flex items-start gap-2"><AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />{w}</div>)}
    </div>
  );
}
